/// <reference path="../../../../app.definition.ts" />

import { ChartTypeEnum, FilterActionsEnum } from "@/app/common/model/analytics.model";
import _ from "lodash";
import * as echarts from 'echarts';
import * as angular from "angular";
import { IAppRootScopeService } from "@/app/app.definition";
import { JavaApiAdapterService } from "@common/apiadapter/javaapi.service";
import { ChartService } from "@common/service/chart.service";
import { TableService } from "@common/service/table.service";
import { BroadcastService } from "@common/service/broadcast.service";
import { CacheService } from "@common/service/cache.service";
import { CommonService } from "@common/common.service";
import { FieldService } from "@common/service/field.service";
import { FormService } from "@common/service/form.service";
import { WebSocketService } from "@common/service/web-socket.service";

interface ITooltipParentScope extends angular.IScope {
    isOpen: boolean;
}

interface IEcvChart {
    init(): void;
}

class EcvChart implements IEcvChart {
    config;
    chartId;
    statistics;
    data;
    chartOptions;
    chartData;
    $_chartService;
    chart;
    $_timeout;
    hasData;
    chartTypes;
    query;
    pagination;
    allowExport;
    export;
    eFileName;
    showData = true;
    ecvId;
    isPopup;
    subjectId;
    user;
    isDynamicPagination = false;
    isDownloadDisable: boolean;
    static $inject = ["$scope", "$timeout", "$rootScope", "BroadcastService", "ChartService", "TableService", "FieldService", "FormService", "ApiAdapterService", "CacheService", "WebSocketService", "CommonService"];


    constructor(
        $scope: ng.IScope,
        $timeout: ng.ITimeoutService,
        private $rootScope: IAppRootScopeService,
        private BroadcastService: BroadcastService,
        ChartService: ChartService,
        private TableService: TableService,
        private FieldService: FieldService,
        private FormService: FormService,
        private ApiAdapterService: JavaApiAdapterService,
        private $_cache: CacheService,
        private WebSocketService: WebSocketService,
        private CommonService: CommonService
    ) {
        this.$_chartService = ChartService;
        this.$_timeout = $timeout;
        this.user = this.$_cache.getUser();
        this.isDownloadDisable = false;
        let query;
        BroadcastService.registerCallBack('print-started', $scope.$id, () => {
            const chartDataLoaded = () => {
                // for chart type = line all the data is pre loaded and
                // for chart type = table data if there is only one page of data then whole table data is loaded by default.
                $timeout(() => {
                    BroadcastService.broadcast('chart-data-loaded');
                }, 0);
            }
            if (this.hasData && this.config.type == ChartTypeEnum.TABLE) {
                query = _.clone(this.query);
                if ((Math.ceil(this.chartData.length / this.query.limit) == 1)) {
                    chartDataLoaded();
                }
                else {
                    this.chartData.length >= 1 ?
                        this.query.limit = this.chartData.length : chartDataLoaded()
                }
            } else {
                chartDataLoaded();
            }
        });

        BroadcastService.registerCallBack('print-completed', $scope.$id, () => {
            if (this.hasData && this.config.type == ChartTypeEnum.TABLE) {
                this.query.limit = query.limit;
                $timeout(() => {
                    this.query.page = query.page;
                }, 0);
            }
        });
        BroadcastService.registerCallBack('enable-download-btn', $scope.$id, () => {
            this.isDownloadDisable = false;
        });
        BroadcastService.registerCallBack('initChart', $scope.$id, () => {
            $timeout(() => {
                this.init();
            }, 0);
        });

        BroadcastService.registerCallBack('disposeChart', $scope.$id, () => {
            !!this.chart && this.chart.dispose();
            this.chartData = null;
            this.query = {};
            this.pagination = {};
        });

        BroadcastService.registerCallBack('resetDataView', $scope.$id, () => {
            $timeout(() => {
                this.init(true);
            }, 0);
        });

        $scope.$on('$destroy', () => {
            $('md-table-container.chart').off('scroll');
            BroadcastService.removeCallBack('initChart', $scope.$id);
            BroadcastService.removeCallBack('disposeChart', $scope.$id);
            BroadcastService.removeCallBack('resetDataView', $scope.$id);
            BroadcastService.removeCallBack('print-started', $scope.$id);
            BroadcastService.removeCallBack('print-completed', $scope.$id);
            BroadcastService.removeCallBack('enable-download-btn', $scope.$id);
        });
        this.chartTypes = ChartTypeEnum;
    }

    getBGColor = (tData) => {
        return {
            backgroundColor: tData.bgColor
        };
    };

    exportJson = (type) => {
        switch (type) {
            case 'csv':
                if (!!this.isDynamicPagination) {
                    this.isDownloadDisable = true;
                    let inputParams = _.get(this.config, 'options.updated', null);
                    inputParams.size = _.get(this.data, 'totalElements', null);
                    inputParams.page = 0;
                    let reportParams = _.get(this.config, 'options.export', null)
                    let d = new Date();
                    let payload = {
                        inputParams,
                        "key": reportParams.params.reportKey,
                        "exportType": reportParams.params.exportType,
                        "fileName": `${reportParams.fileName}-${d.getTime()}`,
                        "orgId": this.user.organizationId,
                        "id": this.CommonService.uuidv4(),
                    }
                    this.ApiAdapterService.downloadReportCSV(payload).then((doc) => {
                        this.WebSocketService.startDwnldTasks([doc], null, true)
                    })
                } else {
                    this.TableService.exportToCSV(this.chartData, this.export.config, this.config.options.columns, this.query.order);
                }
                break;
        }

    }

    navigateTo = (event, row, config) => {
        this.FormService.navigateTo(event, row, config, this.subjectId);
        !!this.isPopup && this.BroadcastService.broadcast('dismiss-modal');
    }

    initChart = (chartParentId) => {
        this.$_timeout(() => {
            const element = document.getElementById(chartParentId);
            if (element) {
                this.chart = echarts.init(element);
                if (this.config) {
                    this.chart.showLoading();
                    this.chart.setOption(this.chartOptions);
                    this.chart.hideLoading();
                }
            } else {
                throw ("Chart container with id " + chartParentId + " not found.");
            }
            this.$rootScope.mainShowLoader = false;
        }, 500);
    }

    init = (isReset = false) => {
        if (this.config && this.data) {
            this.chartId = 'chart_' + this.config.type + '_' + this.config.id;
            this.isDownloadDisable = false;
            switch (this.config.type) {
                case ChartTypeEnum.LINE:
                    this.chartData = this.$_chartService.getProcessedData(this.config, this.data);
                    this.hasData = (this.chartData.length > 0);
                    if (this.hasData) {
                        this.chartOptions = this.$_chartService.processOptions(this.config, this.chartData);
                        this.statistics = this.$_chartService.getStatistics(this.config.statistics, this.chartData);
                        this.initChart(this.chartId);
                    }
                    break;
                case ChartTypeEnum.TABLE:
                    if (!isReset) {
                        const defaults = this.config.options.defaults;
                        const pagination = this.config.options.pagination;
                        const exportC = this.config.options.export;
                        const sortOn = this.isDynamicPagination ? defaults.sortOn.propertiesWithType[0].name : defaults.sortOn;
                        this.query = {
                            order: sortOn || this.config.options.columns[0].field,
                            limit: defaults.rowsPerPage || 10,
                            page: defaults.page || 1
                        };
                        this.pagination = {
                            required: pagination.required || false,
                            showPageSelect: pagination.showPageSelectDD || false,
                            showFirstLastPage: pagination.showFirstLastPageLink || false,
                            pageOptions: pagination.pageOptions || [5, 10, 15, 20]
                        }
                        let fn = this.FieldService.handleParams({ "filename": exportC.fileName });
                        this.export = {
                            config: {
                                fileName: fn.filename || "New File",
                                columns: exportC.columns || []
                            },
                            to: {
                                csv: exportC.csv || false
                            }
                        }
                        this.allowExport = (_.map(this.export.to, function (n) { return n }).indexOf(true) != -1);
                    }
                    if (!!this.config.settings && !!this.config.settings.events && !!this.config.settings.events.onFilter) {
                        let onFilter = this.config.settings.events.onFilter;
                        let service = this.FieldService.fields;
                        if (onFilter.type == FilterActionsEnum.TOGGLE_COLUMN && Array.isArray(onFilter.columnIds) && !!onFilter.showWhen) {
                            try {
                                let show = eval(onFilter.showWhen);
                                let cols = this.config.options.columns.filter(col => _.includes(onFilter.columnIds, col.id));
                                cols.forEach(c => {
                                    c.isHidden = !show;
                                });
                            } catch (e) {
                                console.log(e);
                            }
                        } else if (onFilter.type == FilterActionsEnum.TOGGLE_TABLE && !!onFilter.showWhen) {
                            try {
                                this.showData = eval(onFilter.showWhen);
                            } catch (e) {
                                console.log(e);
                            }
                        }
                    }
                    let chartData: [] = this.data;
                    if (!!this.isDynamicPagination) {
                        chartData = this.data.content
                    }
                    if (!!this.config.dataProcessing && !!this.config.dataProcessing.required) {
                        this.chartData = this.FieldService.processTableData(_.cloneDeep(chartData), this.config.dataProcessing.process, this.config);
                    } else {
                        this.chartData = chartData;
                    }
                    this.hasData = (this.chartData.length > 0);
                    this.$_timeout(() => {
                        this.$rootScope.mainShowLoader = false;
                        $('md-table-container.chart').on('scroll', function () {
                            const scope = angular.element('.tooltip.tt-more').scope();
                            if (scope && scope.$parent) {
                                // Use a type assertion to tell TypeScript about the custom property
                                const parentScope = scope.$parent as ITooltipParentScope;

                                // Use the correctly typed parentScope
                                parentScope.$apply(function () {
                                    parentScope.isOpen = false;
                                });
                            }
                        });
                    }, 500);
                    break;
            }
        }
    }

    onReorder = (value) => {
        this.$rootScope.mainShowLoader = true;
        let val = _.replace(value, '-', '')
        let fielddortConfig = _.get(this.config, "options.columns").filter((a) => {
            return a.field == val
        })

        let sortObj = {
            direction: value.includes('-') ? "DESC" : "ASC",
            propertiesWithType: [{
                name: val,
                type: fielddortConfig[0]['sorting'].type,
            }],
            chartId: this.config.id
        }
        this.BroadcastService.broadcast('sort-chart', [sortObj]);
    }
    loadData = (value, limit) => {
        this.$rootScope.mainShowLoader = true;
        let paginationObj = {
            page: value - 1,
            size: limit,
            chartId: this.config.id
        }
        this.BroadcastService.broadcast('chart-pagination', [paginationObj]);
    }
    tableLoaded = () => {
        this.BroadcastService.broadcast('chart-data-loaded');
    }
}

function ecvChart(): ng.IDirective {
    return {
        restrict: 'E',
        templateUrl: 'app/common/analyticsReport/components/chart/chart.directive.html',
        replace: true,
        controller: EcvChart,
        controllerAs: 'cVm',
        scope: true,
        bindToController: {
            'config': '=',
            'data': '=',
            'hasData': '=',
            'subjectId': "=?",
            'isPopup': '=',
            'isDynamicPagination': "="
        },
        link: (scope: ng.IScope, element: ng.IAugmentedJQuery, attributes: ng.IAttributes, controller: IEcvChart): void => {

        }
    }
}

angular.module('eCareVault.common.analyticsReport').directive('ecvChart', ecvChart);

